import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CertificatedCachedResourceService } from './certificate-cached-resource.service';
import { CertificateResourceService } from './certificate-resource.service';
import { ApiResourceModule } from '../api-resource/api-resource.module';

@NgModule({
  imports: [CommonModule, ApiResourceModule],
  declarations: [],
  exports: [],
  providers: [CertificateResourceService, CertificatedCachedResourceService],
})
export class CertificateResourceModule {}
